import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from "../views/auth/LoginView";
import Processing from "@/views/auth/Processing";
import TablesView from "@/views/table/TablesView";
import TableView from "@/views/table/TableView";
import CompleteSignUp from "@/views/auth/CompleteSignUp";
import BroadcastsView from "@/views/broadcast/BroadcastsView";
import PrivacyView from "@/views/PrivacyView";
import authGuard from "@/router/auth-guard";
import UsersView from "@/views/users/UsersView";
import BroadcastGroups from "@/views/broadcast/BroadcastGroups.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: LoginView
  },
  {
    path: '/login',
    name: 'home',
    component: LoginView
  },
  {
    path: '/processing',
    name: 'home',
    component: Processing
  },
  {
    path: '/tables',
    name: 'Table',
    beforeEnter: authGuard,
    component: TablesView
  },
  {
    path: '/users',
    name: 'Users',
    beforeEnter: authGuard,
    component: UsersView
  },
  {
    path: '/broadcasts',
    name: 'Broadcasts',
    beforeEnter: authGuard,
    component: BroadcastsView
  },
  {
    path: '/tables/:id',
    props: true,
    name: 'Table',
    beforeEnter: authGuard,
    component: TableView
  },
  {
    path: '/broadcast/groups',
    props: true,
    name: 'Message Groups',
    beforeEnter: authGuard,
    component: BroadcastGroups
  },
  {
    path: '/complete_signup',
    props: true,
    name: 'Complete Sign Up',
    beforeEnter: authGuard,
    component: CompleteSignUp
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: PrivacyView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
